import { c as _c } from "react/compiler-runtime";
import { PreviewMessage, ThinkingMessage } from "./message";
import { Greeting } from "./greeting";
import { memo } from "react";
import equal from "fast-deep-equal";
import { motion } from "framer-motion";
import { useMessages } from "@/hooks/use-messages";
function PureMessages(t0) {
  const $ = _c(30);
  const {
    chatId,
    status,
    messages,
    setMessages,
    reload
  } = t0;
  let t1;
  if ($[0] !== chatId || $[1] !== status) {
    t1 = {
      chatId,
      status
    };
    $[0] = chatId;
    $[1] = status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    containerRef: messagesContainerRef,
    endRef: messagesEndRef,
    onViewportEnter,
    onViewportLeave
  } = useMessages(t1);
  let t2;
  if ($[3] !== messages.length) {
    t2 = messages.length === 0 && <Greeting />;
    $[3] = messages.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== chatId || $[6] !== messages || $[7] !== reload || $[8] !== setMessages || $[9] !== status) {
    let t4;
    if ($[11] !== chatId || $[12] !== messages.length || $[13] !== reload || $[14] !== setMessages || $[15] !== status) {
      t4 = (t5, index) => {
        const {
          isUpvoted,
          ...message
        } = t5;
        return <PreviewMessage isUpvoted={isUpvoted} key={message.id} chatId={chatId} message={message} isLoading={status === "streaming" && messages.length - 1 === index} setMessages={setMessages} reload={reload} />;
      };
      $[11] = chatId;
      $[12] = messages.length;
      $[13] = reload;
      $[14] = setMessages;
      $[15] = status;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t3 = messages.map(t4);
    $[5] = chatId;
    $[6] = messages;
    $[7] = reload;
    $[8] = setMessages;
    $[9] = status;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[17] !== messages || $[18] !== status) {
    t4 = status === "submitted" && messages.length > 0 && messages[messages.length - 1].role === "user" && <ThinkingMessage />;
    $[17] = messages;
    $[18] = status;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== messagesEndRef || $[21] !== onViewportEnter || $[22] !== onViewportLeave) {
    t5 = <motion.div ref={messagesEndRef} className="shrink-0 min-w-[24px] min-h-[24px]" onViewportLeave={onViewportLeave} onViewportEnter={onViewportEnter} />;
    $[20] = messagesEndRef;
    $[21] = onViewportEnter;
    $[22] = onViewportLeave;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== messagesContainerRef || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5) {
    t6 = <div ref={messagesContainerRef} className="flex flex-col text-base w-full min-w-0 gap-6 flex-1 overflow-y-scroll pt-4 relative">{t2}{t3}{t4}{t5}</div>;
    $[24] = messagesContainerRef;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
}
export const Messages = memo(PureMessages, (prevProps, nextProps) => {
  if (prevProps.status !== nextProps.status) return false;
  if (prevProps.status && nextProps.status) return false;
  if (prevProps.messages.length !== nextProps.messages.length) return false;
  if (!equal(prevProps.messages, nextProps.messages)) return false;
  return true;
});